import { useMemo } from 'react';
import flowRight from 'lodash-es/flowRight';
import { considerRichContent, considerSimpleContent } from '../../utils';

const cleanEmailContent = (text) => {
  if (!text) return '';

  const isEmailContent = text.includes('mailto:') || 
                        text.includes('MsoNormal') || 
                        text.includes('xmsonormal');

  if (!isEmailContent) {
    return text;
  }

  try {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;

    const scripts = tempDiv.getElementsByTagName('script');
    const styles = tempDiv.getElementsByTagName('style');
    while (scripts.length > 0) scripts[0].remove();
    while (styles.length > 0) styles[0].remove();

    const tables = tempDiv.getElementsByTagName('table');
    while (tables.length > 0) {
      const table = tables[0];
      const textContent = table.textContent;
      const p = document.createElement('p');
      p.textContent = textContent;
      table.parentNode.replaceChild(p, table);
    }

    const cleanNode = (node) => {
      if (node.nodeType === 1) {
        const attrs = node.attributes;
        for (let i = attrs.length - 1; i >= 0; i--) {
          const attr = attrs[i];
          if (!(node.tagName === 'A' && attr.name === 'href')) {
            node.removeAttribute(attr.name);
          }
        }
        
        Array.from(node.childNodes).forEach(cleanNode);
      }
    };

    cleanNode(tempDiv);

    let cleanedHtml = tempDiv.innerHTML;

    cleanedHtml = cleanedHtml
      .replace(/<\/?o:[^>]*>/g, '') // Remove Office tags
      .replace(/<!--[\s\S]*?-->/g, '') // Remove comments
      .replace(/<(\/?)(?!p|br|a|b|i|strong|em|blockquote)[^>]*>/g, '') // Remove unwanted tags
      .replace(/(<br\s*\/?>){3,}/g, '<br/><br/>') // Normalize breaks
      .replace(/\s{2,}/g, ' ') // Normalize spaces
      .trim();

    return cleanedHtml;
  } catch (error) {
    return text;
  }
};

export const useSimpleContentValidation = (text) => {
  const { isPassing } = useMemo(() => {
    try {
      const cleanedText = cleanEmailContent(text);
      return flowRight(
        considerRichContent,
        considerSimpleContent
      )({ text: cleanedText, isPassing: true });
    } catch (error) {
      return { isPassing: true };
    }
  }, [text]);

  return isPassing;
};
